<script setup lang="ts">
import { LinkTarget } from "~/components/Utils/Markdown.types"
import { CategoryProps } from "./Category.props"

withDefaults(defineProps<CategoryProps>(), {
  linkTarget: LinkTarget.self
})
</script>

<template>
  <div
    class="
      text_blocks-category
      px-4
      pb-4
      pt-6
      md:px-[71px]
      md:pb-8
      md:pt-8
      lg:px-[228px]
    "
  >
    <h3
      v-if="title"
      class="dolphin-bold md:mammoth-bold lg:elephant-bold text-black-main mb-5"
      :class="{ 'pb-19px col-span-full md:pb-[0px]': isGrid }"
    >
      {{ title }}
    </h3>

    <div
      class="list-categories space-y-5 md:columns-4 md:space-y-0"
      v-if="isGrid"
    >
      <div
        class="single-category inline-block w-full space-y-2 md:space-y-4"
        v-for="(category, i) in listCategories"
        :key="`category-${i}`"
      >
        <UtilsButton
          class="
            custom-btn-pig-bold
            md:custom-btn-hyppo-bold
            custom-btn-no-padding
            block
            [&>span]:justify-start
            [&>span]:whitespace-normal
            [&>span]:break-all
          "
          :text="category.title.text"
          :path="category.title.path ?? '#'"
          theme="ghost-green"
          order="last"
        >
          <template #icon>
            <IconsArrowRight class="h-5 w-5" />
          </template>
        </UtilsButton>

        <div class="flex flex-col space-y-4 md:pb-6">
          <div
            class="inline-block"
            v-for="(item, index) in category.items"
            :key="`list${index}`"
          >
            <UtilsButton
              class="
                custom-btn-left-normal-whitespace
                custom-btn-start
                custom-btn-no-padding
              "
              :class="{ 'list beaver-medium-underlined': isGrid }"
              :text="item.text"
              :path="item.path ?? '#'"
              theme="link-black"
            />
          </div>
        </div>
      </div>
    </div>

    <UtilsMarkdown
      v-else-if="description"
      class="beaver md:pig"
      useLinkStyle
      :linkTarget="linkTarget"
      :content="description"
      :inline="false"
    />
  </div>
</template>

<style scoped lang="scss">
.list {
  @apply col-span-full pl-0 text-left md:col-span-3;
}
</style>
